import { Component, EventEmitter, HostListener, Input, Output } from "@angular/core";

@Component({
  selector: 'app-poshvine-multiselect-panel',
  templateUrl: './multiselect-panel.component.html',
  styleUrls: ['./multiselect-panel.component.scss']
})
export class MultiselectPanelComponent {
  @Input() panelDetails: any;
  @Input() protected windowSize: 'mobile' | 'tablet' | 'desktop' | 'laptop' = 'desktop';
  @Input() isContentLoading = false;

  @Output() protected btnClickEvent:EventEmitter <any> =  new EventEmitter<any>();

  constructor() {

  }
  ngOnInit() {
    console.log(this.panelDetails, 'MultiselectPanelComponent ');
    this.onResize();
  }
  clickEvent(action:string,item:any,index:number){
    this.btnClickEvent.emit({action,item,index});
  }
  @HostListener('window:resize', ['$event'])
  protected onResize() {
    let prevWindow = this.windowSize;
    if (window.innerWidth >= 1200) {
      this.windowSize = 'desktop';
    } else if (window.innerWidth >= 992) {
      this.windowSize = 'laptop';
    } else if (window.innerWidth >= 768) {
      this.windowSize = 'tablet';
    } else {
      this.windowSize = 'mobile';
    }
    // console.log(this.windowSize, 'WindowSizeService >>>> onResize', prevWindow);
    /*   if (this.initialLoad || prevWindow !== this.windowSize) {
        this.renderDataAndView();
        this.initialLoad = false;
      } */
  }
}
